module.exports = __webpack_public_path__ + "static/media/new-sikka-logo-dark.9c1b43d1.png";